import { DateRangePickerInput } from '@sequencehq/core-components'
import { NARROW_INPUT_WIDTH } from 'Invoices/components/CreateEditShared/constants'
import { FieldLabel } from '../layout'

export type ServicePeriodField = { start: Date; endInclusive: Date } | undefined

type Props = {
  servicePeriod: ServicePeriodField
  setServicePeriod: (next: ServicePeriodField) => void
}

export const ServicePeriodField = ({
  servicePeriod,
  setServicePeriod
}: Props) => {
  return (
    <FieldLabel label="Service period">
      <DateRangePickerInput
        data-testid="lineItemEditor.servicePeriod"
        withOptions={false}
        value={
          servicePeriod
            ? [servicePeriod.start, servicePeriod.endInclusive]
            : undefined
        }
        onChange={([start, endInclusive]) =>
          setServicePeriod({ start, endInclusive })
        }
        popoverPlacement="end"
        inputWidth={NARROW_INPUT_WIDTH}
        iconPlacement="trailing"
      />
    </FieldLabel>
  )
}
